/**
 * The hotel amounts the console shows are the airline's PRICE — operator-bff converts
 * Nexa's cost with the commercial contract's price card before anything leaves the
 * server (`docs/verticals/commercial-contract.md` §6.13). When the card cannot be read
 * the BFF sends `null` (D17): the screen says «No disponible», never 0, never a guess.
 *
 * The copy is the one the spend tile already uses (`operateCancel:spend.unpriced` /
 * `unpricedHint`), so "not available" reads the same everywhere.
 */

export const UNPRICED_KEY = 'operateCancel:spend.unpriced';
export const UNPRICED_HINT_KEY = 'operateCancel:spend.unpricedHint';

/** A real, showable price — a finite number (not `null` / `undefined`). Pure. */
export function isPriced(amount: number | null | undefined): amount is number {
  return typeof amount === 'number' && Number.isFinite(amount);
}

/**
 * Σ of prices, or `null` when any of them is not available — a partial sum would read
 * as the whole (never shown). An empty list sums to 0. Pure.
 */
export function sumPrices(amounts: ReadonlyArray<number | null | undefined>): number | null {
  let total = 0;
  for (const a of amounts) {
    if (!isPriced(a)) return null;
    total += a;
  }
  return Math.round(total * 100) / 100;
}
